import { render, staticRenderFns } from "./SelectDicValue.vue?vue&type=template&id=2c04374b&scoped=true"
import script from "./SelectDicValue.vue?vue&type=script&lang=js"
export * from "./SelectDicValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c04374b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c04374b')) {
      api.createRecord('2c04374b', component.options)
    } else {
      api.reload('2c04374b', component.options)
    }
    module.hot.accept("./SelectDicValue.vue?vue&type=template&id=2c04374b&scoped=true", function () {
      api.rerender('2c04374b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DicValue/SelectDicValue.vue"
export default component.exports